/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable()
export class RegistrationService {
  private registerUrl: string = environment.host + '/register';
  private passwordUrl: string = environment.host + '/reset';
  private savePasswordUrl: string = environment.host + '/password';

  constructor(private http: HttpClient) {}

  public authenticateLoginDetails(token: any) {
    const registerUrl = this.registerUrl.toString() + '/' + token;
    return this.http.get(registerUrl).toPromise();
  }

  public authenticateResetLoginDetails(token: any) {
    const passwordUrl = this.passwordUrl.toString() + '/' + token;
    return this.http.get(passwordUrl).toPromise();
  }

  public saveRegistrationDetails(payload: any) {
    const savePasswordUrl = this.savePasswordUrl.toString();
    return this.http.put(savePasswordUrl, payload).toPromise();
  }
}
